export function formatMoney(value: number, locale = 'pt-BR', currency = 'BRL'): string {
  return Intl.NumberFormat(locale, { style: 'currency', currency }).format(value);
}
